/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylenortheast4Inputs */



/**
* | output |
* | --- |
* | "Warm Roaster" |
*
* @param {Personalityhumorstylenortheast4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylenortheast4 = /** @type {((inputs?: Personalityhumorstylenortheast4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylenortheast4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Warm Roaster")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bromista cálido")
	return /** @type {LocalizedString} */ ("Теплый подколист")
});
export { personalityhumorstylenortheast4 as "personalityHumorStyleNorthEast" }